import type { PerpsMarket } from "./types";

type BuildMarketsParams = {
  collateralSynthMarketId: string;
  collateralTokenAddress: string;
};

export function buildAvantisMarkets({
  collateralSynthMarketId,
  collateralTokenAddress,
}: BuildMarketsParams): PerpsMarket[] {
  return [
    {
      key: "eth",
      label: "ETH / USD",
      // Avantis pairIndex: ETH/USD=0, BTC/USD=1
      marketId: "0",
      chartSymbol: "BINANCE:ETHUSDT",
      defaultPriceUsd: "2000",
      synthMarketId: collateralSynthMarketId,
      collateralTokenAddress,
      collateralDecimals: 18,
    },
    {
      key: "btc",
      label: "BTC / USD",
      marketId: "1",
      chartSymbol: "BINANCE:BTCUSDT",
      defaultPriceUsd: "60000",
      synthMarketId: collateralSynthMarketId,
      collateralTokenAddress,
      collateralDecimals: 18,
    },
  ];
}
